<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 监控中心 </el-breadcrumb-item>
          <el-breadcrumb-item>调控管理</el-breadcrumb-item>
          <el-breadcrumb-item>调控列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="l-list" style="margin-bottom: 50px">
        <cn-select-search
          v-model="companyId"
          :v_whole="true"
          :data="companyList"
          @val="setCompanyId"
          placeholder="请筛选客户..."
        >
        </cn-select-search>
        <el-select
          v-model="cabinetId"
          placeholder="请选择设备..."
          class="sb_select"
        >
          <el-option :key="0" label="全部设备" :value="0"></el-option>
          <el-option
            v-for="item in cabinetList"
            :key="item.id"
            :label="`${item.cabinetCode}  /  ${item.cabinetName}`"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          slot="append"
          icon="el-icon-search"
          @click="initData"
        ></el-button>
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-circle-plus"
            @click="addPlan()"
            >新增计划</el-button
          >
        </el-button-group>
      </div>
      <div class="content-box">
        <el-card class="table-card" style="padding-right: 10px">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
            :expand-row-keys="expandedRows"
            row-key="id"
            style="padding-bottom: 10px"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  v-loading="loading"
                  v-if="props.row.detailList.length > 0"
                  :data="props.row.detailList"
                  :header-cell-style="{ height: '10px' }"
                >
                  <el-table-column
                    prop="planLoad"
                    label="计划调控负荷（单位：KW）"
                    min-width="120"
                    align="center"
                  >
                  </el-table-column>

                  <el-table-column
                    prop="startTime"
                    label="开始时间"
                    min-width="55"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="endTime"
                    label="结束时间"
                    min-width="55"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="createdBy"
                    label="创建人"
                    min-width="90"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="gmtCreate"
                    label="创建时间"
                    min-width="100"
                    align="center"
                  >
                    <!-- <template slot-scope="scope">
                      <span class="nowrap" style="display: block">{{
                        scope.row.gmtCreate.split(" ")[0]
                      }}</span>
                      <span class="nowrap" style="display: block">{{
                        scope.row.gmtCreate.split(" ")[1]
                      }}</span>
                    </template> -->
                  </el-table-column>

                  <!-- <el-table-column
                    prop="planId"
                    label="计划id"
                    min-width="80"
                    align="center"
                  >
                  </el-table-column> -->

                  <!-- <el-table-column
                    prop="planTime"
                    label="计划时间"
                    min-width="70"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span class="nowrap" style="display: block">{{
                        scope.row.planTime.split(" ")[0]
                      }}</span>
                      <span class="nowrap" style="display: block">{{
                        scope.row.planTime.split(" ")[1]
                      }}</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="source"
                    label="来源"
                    min-width="50"
                    align="center"
                  >
                  </el-table-column>

                  <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        icon="el-icon-edit"
                        v-if="props.row.accept == 0"
                        @click="linkUrl(scope.row, props)"
                      ></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        v-if="props.row.accept == 0"
                        @click="deleteDetailsItem(scope.row.id)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="props.row.detailList.length == 0"
                  style="text-align: center"
                >
                  暂无数据
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="公司名称"
              prop="companyName"
              min-width="90"
              align="center"
            >
            </el-table-column>
            <el-table-column label="计划时间" width="90">
              <template slot-scope="scope">
                <span class="nowrap" style="display: block">{{
                  scope.row.planTime.split(" ")[0]
                }}</span>
                <span class="nowrap" style="display: block">{{
                  scope.row.planTime.split(" ")[1]
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="source"
              label="来源"
              min-width="70"
              align="center"
            >
            </el-table-column>
            <el-table-column label="状态" width="60">
              <template slot-scope="scope">
                <!-- <span class="nowrap" v-if="scope.row.accept == 0">
                  <el-radio-group
                    v-model="scope.row.accept"
                    @input="handlePaymentChange(scope.row)"
                    aria-hidden="false"
                    v-bind="$attrs"
                  >
                    <el-radio :label="1">接收</el-radio>
                    <el-radio :label="2">拒绝</el-radio>
                  </el-radio-group>
                </span> -->
                <span class="nowrap" v-if="scope.row.accept == 0">待确认</span>
                <span class="nowrap" v-if="scope.row.accept == 1">接受</span>
                <span class="nowrap" v-if="scope.row.accept == 2">拒绝</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="企业code"
              prop="creditCode"
              min-width="155"
              align="center"
            >
            </el-table-column> -->
            <!-- <el-table-column
              prop="companyId"
              label="设备公司id"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyId }}
                </h4>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="equipNo"
              label="设备编码"
              min-width="80"
              align="center"
            ></el-table-column>
            <!-- <el-table-column
              prop="deviceId"
              label="设备id"
              min-width="140"
              align="center"
            >
            </el-table-column> -->
            <!-- <el-table-column label="资源类型" min-width="80" align="center">
              <template slot-scope="scope">
                <span class="nowrap" v-if="scope.row.resourceType == 1"
                  >配电房</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 2"
                  >中央空调</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 3"
                  >光伏电站</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 4"
                  >风电场站</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 5"
                  >充换电站</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 6"
                  >储能电站</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 7"
                  >能源站</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 8"
                  >火电厂</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 9"
                  >楼宇</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 10"
                  >变电站</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 11"
                  >间隔</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 12"
                  >能源站子系统</span
                >
                <span class="nowrap" v-if="scope.row.resourceType == 13"
                  >能源单元（含基站）</span
                >
              </template>
            </el-table-column>

            <el-table-column label="设备类型" min-width="90">
              <template slot-scope="scope">
                <span class="nowrap" v-if="scope.row.equipType == 1">负荷</span>
                <span class="nowrap" v-if="scope.row.equipType == 2"
                  >开关电源</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 3"
                  >空调主机</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 4"
                  >空调风机</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 5"
                  >光伏逆变器</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 6"
                  >汇流箱</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 7">风机</span>
                <span class="nowrap" v-if="scope.row.equipType == 8"
                  >储能电池</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 9"
                  >储能电池簇</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 10"
                  >储能电池组</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 11"
                  >储能变流器</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 12"
                  >充电桩</span
                >
                <span class="nowrap" v-if="scope.row.equipType == 13"
                  >充电枪
                </span>
              </template>
            </el-table-column> -->

            <el-table-column
              prop="createdBy"
              label="创建人"
              min-width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="modifiedBy"
              label="修改人"
              min-width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column label="创建时间" width="90">
              <template slot-scope="scope">
                <span class="nowrap" style="display: block">{{
                  scope.row.gmtCreate.split(" ")[0]
                }}</span>
                <span class="nowrap" style="display: block">{{
                  scope.row.gmtCreate.split(" ")[1]
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="gmtModified"
              label="修改时间"
              min-width="90"
              align="center"
            >
              <template slot-scope="scope">
                <span class="nowrap" style="display: block">{{
                  scope.row.gmtModified.split(" ")[0]
                }}</span>
                <span class="nowrap" style="display: block">{{
                  scope.row.gmtModified.split(" ")[1]
                }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              min-width="150"
              align="center"
              style="display: flex; justify-content: space-around"
            >
              <template slot-scope="scope">
                <div style="margin-bottom: 10px; display: flex">
                  <el-button
                    size="mini"
                    icon="el-icon-check"
                    type="success"
                    v-if="
                      scope.row.accept == 0 && scope.row.detailList.length != 0
                    "
                    @click="handlePaymentChange(scope.row, 1)"
                    >接受</el-button
                  >
                  <el-button
                    size="mini"
                    type="warning"
                    icon="el-icon-close"
                    v-if="
                      scope.row.accept == 0 && scope.row.detailList.length != 0
                    "
                    @click="handlePaymentChange(scope.row, 2)"
                    >拒绝</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    v-if="scope.row.accept == 0"
                    @click="deleteItem(scope.row.id)"
                  ></el-button>
                </div>
                <div style="display: flex">
                  <el-button
                    size="mini"
                    icon="el-icon-circle-plus"
                    v-if="scope.row.accept == 0"
                    @click="addRegulation(scope.row)"
                  ></el-button>
                  <el-button
                    size="mini"
                    @click="copy(scope.row)"
                    v-if="scope.row.detailList.length != 0"
                    >复制</el-button
                  >
                  <el-button
                    size="mini"
                    @click="withdraw(scope.row)"
                    v-if="compare(scope.row)"
                    >撤回</el-button
                  >
                  <el-button
                    size="mini"
                    icon="el-icon-edit"
                    v-if="scope.row.accept == 0"
                    @click="linkUrlReg(scope.row)"
                  ></el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      companyList: [],
      inheritAttrs: false,
      radio: "",
      isShow: false,
      disabled: false,
      companyId: "",
      cabinetId: "",
      chargeType: "",
      loading: false,
      dateRange: [],
      iconToolsBar: "iconfont icon-d-arrow-down", //更多按钮图标
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      expandedRows: [], // 控制展开的行
      listData: [],
      flagAdd: false,
      flagDel: false,
      flagUpdate: false,
      flagLook: false,
      cabinetList: [],
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "结算中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "充放订单");
        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    withdraw(row) {
      let _this = this;
      this.$confirm("确认要撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          AxiosAjax({
            method: "post",
            url: "/cabinet/cabinet/plan/haiyi/revoke/" + row.id,
            loading: true,
            successMsg: "已撤回成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    compare(row) {
      let nowData = new Date().toISOString().slice(0, 10);
      if (row.accept === 1) {
        if (
          new Date(row.planTime.slice(0, 10)).getTime() >
          new Date(nowData).getTime()
        ) {
          return true;
        } else if (
          new Date(row.planTime.slice(0, 10)).getTime() ===
          new Date(nowData).getTime()
        ) {
          if (row.detailList.length > 0) {
            const latestEndTime = row.detailList.reduce((max, item) => {
              // 将时间字符串转换为分钟进行比较
              const itemMinutes = this.timeToMinutes(item.endTime);
              const maxMinutes = this.timeToMinutes(max.endTime);
              return itemMinutes > maxMinutes ? item : max;
            }).endTime;
            return this.isTimeAfterCurrentTime(latestEndTime);
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    timeToMinutes(timeStr) {
      // 将时间字符串转换为小时和分钟
      const [hours, minutes] = timeStr.split(":").map(Number);
      // 转换为总分钟数
      return hours * 60 + minutes;
    },
    isTimeAfterCurrentTime(timeStr) {
      // 获取当前时间的小时和分钟
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      // 将endTime转换为分钟
      const endTimeMinutes = this.timeToMinutes(timeStr);
      // 比较endTime是否在当前时间之后
      return endTimeMinutes > currentMinutes;
    },
    addPlan() {
      this.$router.push({ name: "RegulationEdit" });
    },
    addRegulation(row) {
      this.$router.push({
        name: "PlanEdits",
        query: {
          id: row.id,
          planTime: row.planTime,
          cabinetCode: row.equipNo,
        },
      });
    },
    linkUrl(row, props) {
      row.equipNo = props.row.equipNo;
      this.$router.push({ name: "PlanEdit", params: row });
    },
    linkUrlReg(row) {
      this.$router.push({ name: "RegulationEdit", params: row });
    },
    copy(row) {
      row.key = 1;
      this.$router.push({ name: "RegulationEdit", params: row });
    },
    handlePaymentChange(row, val) {
      this.$confirm("是否确认？")
        .then((_) => {
          let _this = this;

          AxiosAjax({
            url: "/cabinet/cabinet/plan/haiyi/" + row.id + "/" + val,
            method: "post",
            loading: true,
            success: function (res) {
              _this.initData();
              _this.$message({
                message: "操作成功",
                type: "success",
              });
            },
          });
        })
        .catch((_) => {});
    },
    handleExpandChange(row, expandedRows) {
      this.expandedRows = expandedRows; // 更新展开的行
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/haiyi/plan";

      sendUrl += "?index=" + _this.pageIndex;
      sendUrl += "&size=" + _this.pageSize;
      if (this.companyId && this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }
      if (this.cabinetId) {
        sendUrl += "&cabinetId=" + _this.cabinetId;
      }
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
          if (_this.listData.length > 0) {
            _this.expandedRows = [_this.listData[0].id];
          }
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    deleteDetailsItem(id) {
      let _this = this;
      this.$confirm("确认要删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          AxiosAjax({
            method: "post",
            url: "/cabinet/haiyi/plan/detail/del/" + id,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //单项删除
    deleteItem: function (val) {
      let _this = this;

      //执行删除操作
      this.$confirm("确认要删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          AxiosAjax({
            method: "post",
            url: "/cabinet/haiyi/plan/del/" + val,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
    },
    getCabinetList: function (companyId) {
      let _this = this; //当前页面
      _this.cabinetList = [];
      //加载设备列表
      AxiosAjax({
        url: "/cabinet/cabinet/page?index=1&size=9000&companyId=" + companyId,
        loading: true,
        success: function (res) {
          console.log(res.data.data);
          _this.cabinetList = res.data.data.content;
        },
      });
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
      this.getCabinetList(this.companyId);
    },
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
        _this.getCabinetList(_this.companyId);
      } else {
        _this.isShow = true;
      }
    },
  },
  created: function () {
    //加载数据
    this.initData();
    this.initLoad();
  },
};
</script>
<style scoped>
.content-box .table-list .nowrap {
  white-space: inherit;
}
.sb_select > .el-input {
  width: 130px;
}
.zt_select > .el-input {
  width: 130px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
/deep/ .el-table__expanded-cell {
  padding: 0 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/Regulation/Regulation.vue